<template>
  <div class="notifications-page">
    <div class="container">
      <h1 class="page-header color-1-100">Notifications</h1>
      <div class="content-section">
        <a href="#"
           class="notifications-read-all border-1-20"
           @click.prevent="markAllNotificationsAsRead()">
          <span class="notifications-read-all-icon color-1-100">
            <svg version="1.1" id="icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 12.163 9.729" style="enable-background:new 0 0 12.163 9.729;" xml:space="preserve">
              <polygon class="st0" points="10.394,0 4.841,6.109 1.768,3.035 0,4.804 4.927,9.729 12.163,1.77 "/>
            </svg>
          </span>
          Mark all as read</a>
        <div class="notifications-list">
          <div class="notifications-group" v-for="(item, index) in notifications">
            <div class="item-date" :class="[{ 'unread': item.unread }]">{{ item.date }}</div>
            <div>
              <div class="notifications-item"
                   :class="[{ 'unread': !child.isRead }]"
                   v-for="child in item.children">
                <div class="item-time">{{ child.time }}</div>
                <div class="item-details"
                     @click="readNotification(child)">
                  <template v-if="child.type === 1">
                    <router-link v-if="child.contentId && child.companyId"
                                 :to="{ name: 'company-task', params: { companyId: child.companyId, id: child.contentId } }">{{ child.message }}</router-link>
                  </template>
                  <template v-else-if="child.type === 2 || child.type === 3">
                    <router-link v-if="child.userFromId"
                                 :to="{ name: 'edit-user', params: { id: child.userFromId } }">{{ child.message }}</router-link>
                    <router-link v-if="!child.userFromId"
                                 :to="{ name: 'consent-logs' }">{{ child.message }}</router-link>
                  </template>
                  <template v-else-if="child.type === 4">
                    <router-link v-if="child.contentId"
                                 :to="{ name: 'content', params: { id: child.contentId } }">{{ child.message }}</router-link>
                  </template>
                  <template v-else-if="child.type === 5">
                    <router-link v-if="getUserRole === 'gm'"
                                 :to="{ name: 'company-task', params: { companyId: child.companyId, id: child.contentId } }">{{ child.message }}</router-link>
                    <router-link v-else
                                 :to="{ name: 'task', params: { id: child.contentId } }">{{ child.message }}</router-link>
                  </template>
                  <template v-else>
                    {{ child.message }}
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="notifications-load-more" v-if="loadedCount < allCount">
          <a href="#" @click.prevent="loadMore()">Load more</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import {mapGetters} from 'vuex'

  export default {
    name: 'all-notifications',
    data () {
      return {
        ppt: 10,
        offset: 0,
        limit: 10,
        notifications: [],
        allCount: 0,
        loadedCount: 0,
        allIds: []
      }
    },
    computed: {
      ...mapGetters([
        'getUserRole'
      ])
    },
    methods: {
      getNotifications () {
        let body = {
          offset: this.offset,
          limit: this.limit
        }
        this.$http.post(api.URLS.userNotifications, body, api.headersAuthSettings).then((res) => {
          this.allCount = res.body.count
          let notifications = res.body.notifications
          let temp
          for (let index in notifications) {
            let notification = notifications[index]
            let date = this.convertDate(notification.createdAt, '.')
            let time = this.convertTime(notification.createdAt, ':')
            let group = this.notifications.find((item) => item.date === date)
            let unread = false
            this.loadedCount += 1
            if (unread === false && notification.isRead === 0) {
              unread = true
            }
            this.allIds.push(notification.id)
            temp = {
              type: notification.type,
              userFromId: notification.userFromId,
              id: notification.id,
              contentId: notification.contentId,
              companyId: notification.companyId,
              time: time,
              isRead: notification.isRead,
              message: notification.message
            }
            if (group) {
              group.children.push(temp)
            } else {
              this.notifications.push({
                date: date,
                unread: unread,
                children: [{
                  type: notification.type,
                  userFromId: notification.userFromId,
                  id: notification.id,
                  contentId: notification.contentId,
                  companyId: notification.companyId,
                  isRead: notification.isRead,
                  time: time,
                  message: notification.message
                }]
              })
            }
          }
        }).catch((err) => console.log(err))
      },
      readNotification (item) {
        this.markNotificationsRead([item.id])
        // if (item.type === 1) {
        //   if (item.companyId && item.contentId) {
        //     let props = this.$router.resolve({
        //       name: 'edit-company',
        //       params: {
        //         id: item.companyId
        //       },
        //       query: {
        //         ttd: item.contentId
        //       }
        //     })
        //     this.$router.push(props.href)
        //   }
        // } else if (item.type === 2 || item.type === 3) {
        //   if (item.userFromId) {
        //     let props = this.$router.resolve({
        //       name: 'edit-user',
        //       params: {
        //         id: item.userFromId
        //       }
        //     })
        //     this.$router.push(props.href)
        //   } else {
        //     let props = this.$router.resolve({
        //       name: 'consent-logs'
        //     })
        //     this.$router.push(props.href)
        //   }
        // } else if (item.type === 4 || item.type === 5) {
        //   let props = this.$router.resolve({
        //     name: 'content',
        //     params: {
        //       id: item.contentId
        //     }
        //   })
        //   this.$router.push(props.href)
        // }
      },
      markAllNotificationsAsRead () {
        this.markNotificationsRead([])
      },
      markNotificationsRead (ids) {
        let body = []
        if (ids) {
          body = ids
        }
        this.$http.post(api.URLS.userNotificationsRead, body, api.headersAuthSettings).then((res) => {
          this.notifications = []
          this.offset = 0
          this.limit = 10
          this.getNotifications()
        }).catch((err) => console.log(err))
      },
      convertDate (payload, delimiter) {
        if (!payload) return
        let date = new Date(payload)
        let fullYear = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        function toDoubleDigit (num) {
          return num.toString().length < 2 ? '0' + num : num.toString()
        }
        return toDoubleDigit(day) + delimiter + toDoubleDigit(month) + delimiter + fullYear
      },
      convertTime (payload, delimiter) {
        if (!payload) return
        let date = new Date(payload)
        let hours = date.getHours()
        let minutes = date.getMinutes()
        let ampm = hours >= 12 ? 'pm' : 'am'
        let newHours = hours % 12 ? hours % 12 : 12
        function toDoubleDigit (num) {
          return num.toString().length < 2 ? '0' + num : num.toString()
        }
        return toDoubleDigit(newHours) + delimiter + toDoubleDigit(minutes) + ' ' + ampm
      },
      loadMore () {
        this.offset = this.offset + this.ppt
        this.getNotifications()
      }
    },
    beforeMount () {
      this.getNotifications()
    },
    created () {
      document.title = 'Clear Assured – forgot password'
    }
  }
</script>

<style src="@/assets/scss/main/notifications.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// Notifications.vue?3d6e5cf4